import { Choice, Dialog, Scene } from "../models";
import { scenes } from '../scenes';

const successDialog = [
  new Dialog(" PIN Code successfully entered. Depositing cash... please wait... Cash deposited!]",
    require("@/images/Credit_Card.png"),
    require("@/audio/Found_Jingle.mp3")
  )
]

const tamperDialog = [
  new Dialog(
    "[INCORRECT PIN ENTERED!]",
    require("@/images/ATM.png"),
    require("@/audio/loseitem.mp3")
  ),
  new Dialog("MERCENARY: I get that times are tough, but that’s no reason to go around stealing the Bank’s money.",
    require("@/images/Security.png"),
    require("@/audio/Pandemic-85-Mercenary-MP3.mp3")
  ),
  new Dialog(
    "[The Hired Mercenary shoots you on sight!]",
    require("@/images/Gun.png"),
    require("@/audio/loseitem.mp3")
  )
]

export class ATM extends Scene {
  async init() {
    this.title = "The ATM";
    this.description = "Please enter your 4 digit PIN Code to proceed.";
    this.image = require("@/images/ATM.png");
    this.showInput = true;
  }

  get options() {
    return [
      new Choice("Leave", async () => {
        await this.navigate(scenes.BankInterior())
      }),
      new Choice("Enter PIN", async () => {
        this.showInput = false;
        await this.dialogRunner(successDialog)
        this.state.inventory.creditCard.has = true;
        this.state.inventory.cash.has = false;
        await this.navigate(scenes.BankInterior())
      }),
      new Choice("Tamper with machine", async () => {
        this.showInput = false;
        await this.dialogRunner(tamperDialog)
        await this.navigate(scenes.EmergencyRoom())
      }),
    ]
  }
}

export default new ATM()